import { render, staticRenderFns } from "./PreviewProductModal.vue?vue&type=template&id=63ea0411&scoped=true&"
import script from "./PreviewProductModal.vue?vue&type=script&lang=js&"
export * from "./PreviewProductModal.vue?vue&type=script&lang=js&"
import style0 from "./PreviewProductModal.vue?vue&type=style&index=0&id=63ea0411&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ea0411",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
